import React, { useRef, useState, useEffect } from 'react';

import './styles.css';

import formatterBR, { formatter } from '../../functions/formatCurrency';

import 'intl-tel-input/build/css/intlTelInput.css';
import 'intl-tel-input/build/js/utils.js'
import intlTelInput from 'intl-tel-input';
import PopupNewPhoto from './PopupNewPhoto';
import { FaCamera, FaTimes } from 'react-icons/fa';

function Input(props) {
    const input = useRef(null);
    const [isOnFocus, setIsOnFocus] = useState(false);
    const [selectOptions, setSelectOptions] = useState(null);
    const [inputInstance, setInputInstance] = useState(null);
    const [isInvalid, setIsInvalid] = useState(false);
    const [popupNewPhotoVisible, setPopupNewPhotoVisible] = useState(false);

    let formatterCurrency = props.currency ? formatter(props.currency) : formatterBR;

    useEffect(() => {
        if (input && props.type === "tel" && props.id) {
            // const phoneInputField = document.querySelector(`#${props.id}`);
            setInputInstance(intlTelInput(input.current, {
                preferredCountries: ["br", "us"],
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [input, props.id]);

    useEffect(() => {
        if (props.type === "tel" && props.iso2 && inputInstance)
            inputInstance.setCountry(props.iso2);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.iso2, inputInstance]);

    useEffect(() => {
        if (input && props.type === "tel" && props.setDialCode && inputInstance) {
            // const phoneInputField = document.querySelector(`#${props.id}`);
            setCoutryDatas(inputInstance);
            input.current.addEventListener("countrychange", function () {
                setCoutryDatas(inputInstance);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [input, props.setDialCode, inputInstance]);

    // useEffect(() => {
    //     if (input) {
    //         console.log(input);
    //         console.log(input.current);
    //         console.log(document.querySelector(`#${props.id}`));
    //     }
    // }, [input]);

    useEffect(() => {
        if (!isOnFocus && props.onBlur)
            props.onBlur();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOnFocus]);

    useEffect(() => {
        if (props.type === "tel" && props.setIsValidNumber && inputInstance) {
            const valid = ((!inputInstance.isValidNumber() && inputInstance.getValidationError() == 0) || inputInstance.isValidNumber()) ? true : false;
            props.setIsValidNumber(valid);
            setIsInvalid(!valid);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.value, props.setIsValidNumber, inputInstance]);

    useEffect(() => {
        if (props.type === "select" && props.options) {
            //console.log("options", props.options);
            if (!props.noFilterOptions)
                setSelectOptions(props.options.slice().filter(item => item.toLowerCase().includes(props.value.toLowerCase())));
            else if (selectOptions === null || props.options.toString() !== selectOptions.toString())
                setSelectOptions(props.options.slice());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.type, props.options, props.value]);

    useEffect(() => {
        if (!isOnFocus && props.value !== undefined && (props.type === "number" || props.type === "currency"))
            verifyMinAndMax();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.value, props.onChange, props.type]);

    function setCoutryDatas(inputInstance) {
        const valid = ((!inputInstance.isValidNumber() && inputInstance.getValidationError() == 0) || inputInstance.isValidNumber()) ? true : false;
        props.setDialCode(`+${inputInstance.getSelectedCountryData().dialCode}`);
        props.setIso2(inputInstance.getSelectedCountryData().iso2);
        props.setIsValidNumber(valid);
        setIsInvalid(!valid);
    }

    function verifyMinAndMax() {
        if (props.onChange && props.value !== undefined && (props.type === "number" || props.type === "currency")) {
            let value = Number(props.value);

            if (props.max && value > Number(props.max)) {
                input.current.value = Number(props.max);
                props.onChange({ ...input, target: { value: Number(props.max) } });
            } else if (props.min && value < Number(props.min)) {
                input.current.value = Number(props.min);
                props.onChange({ ...input, target: { value: Number(props.min) } });
            }
        }
    }

    function selectInput(type) {
        switch (type) {
            case "select": return (
                <>
                    <div className="select-input">
                        <input
                            type="text"
                            autoComplete="off"
                            className={'search-select-input' + (props.value === "" || (props.options && props.options.includes(props.value)) ? "" : " invalid-input")}
                            accept={props.accept}
                            name={props.id}
                            id={props.id}
                            placeholder={props.placeholder ? props.placeholder : (!props.options || !props.options.length ? "Não há opções disponíveis" : "Pesquise uma opção")}
                            onFocus={(event) => setIsOnFocus(true)}
                            onBlur={() => setIsOnFocus(false)}
                            value={props.value}
                            onChange={(event) => props.onChange(event)}
                            ref={input}
                        />
                        <div className={"select-options" + (!isOnFocus ? " hide" : "")}>
                            {
                                selectOptions ?
                                    selectOptions.map((item, index) =>
                                        <span
                                            key={index}
                                            className={item === props.value ? "selected" : ""}
                                            onClick={(event) => {
                                                console.log(item);
                                                event.target.value = item;
                                                props.onChange(event);
                                            }}
                                        >
                                            {item}
                                        </span>
                                    )
                                    : []
                            }
                        </div>
                    </div>
                    {/* <select
                        name={props.id}
                        id={props.id}
                        className={(props.placeholderIcon ? 'icon-spaced' : '')}
                        ref={input}
                        value={props.value}
                        onChange={props.onChange}
                        >
                        <option value='' disabled>
                            {props.placeholder ? props.placeholder : (!props.options || !props.options.length ? "Não há opções disponíveis" : "Selecione uma opção")}
                        </option>
                        {
                            props.options ?
                                props.options.map((item, index) => {
                                    return <option key={index} value={item}>{item}</option>
                                })
                                : []
                        }
                    </select> */}
                </>
            );
            case "textarea": return (
                <textarea
                    name={props.id}
                    id={props.id}
                    className={((props.type === 'file' || props.type === 'photo') ? 'file-input' : '') + (props.placeholderIcon ? ' icon-spaced' : '')}
                    placeholder={props.placeholder}
                    rows={props.rows}
                    value={props.value}
                    onChange={props.onChange}
                    ref={input}
                />
            );
            case "checkbox": return (
                <>
                    <input
                        type={props.type ? props.type : 'text'}
                        accept={props.accept}
                        checked={props.checked}
                        name={props.id}
                        id={props.id}
                        className={((props.type === 'file' || props.type === 'photo') ? 'file-input' : '') + (props.placeholderIcon ? ' icon-spaced' : '')}
                        placeholder={props.placeholder}
                        value={props.value}
                        onChange={props.onChange}
                        ref={input}
                    />
                    <label className={"checkbox-label" + (props.bold ? " bold-label" : "")} onClick={() => input.current.click()}>
                        {props.notShowPlaceholder ?
                            null :
                            (
                                props.placeholder ? props.placeholder : "Checkbox"

                            )
                        }
                    </label>
                </>
            );
            default: return (
                <input
                    type={props.type && props.type !== "number" && props.type !== "currency" ? (props.type === 'photo' ? 'file' : props.type) : 'text'}
                    accept={props.accept}
                    name={props.id}
                    id={props.id}
                    onFocus={() => setIsOnFocus(true)}
                    onBlur={() => {
                        setIsOnFocus(false);
                        verifyMinAndMax();
                    }}
                    className={
                        ((props.type === 'file' || props.type === 'photo') ? 'file-input' : '')
                        + (props.placeholderIcon ? ' icon-spaced' : '')
                        + (props.type === "tel" ? ' iti-input' : '')
                        + ((props.value && isInvalid) || (props.fixLength && typeof props.value === "string" && props.value.length !== props.fixLength) ? ' invalid-input' : '')
                    }
                    placeholder={props.type === "tel" ? "" : props.placeholder}
                    // value={(props.type !== 'file' && props.type !== 'photo') ? (props.type === "currency" ? `R$ ${Number(props.value).toFixed(2).replace('.', ',')}` : props.value) : ''}
                    value={(props.type !== 'file' && props.type !== 'photo') ? (props.type === "currency" ? formatterCurrency.format(props.value) : props.value) : ''}
                    // value={(props.type !== 'file' && props.type !== 'photo') ? (props.type !== "number" ? props.value : Number(String(props.value).replace(/,/g, '.').replace(/[^0-9.]/g, ''))) : ''}
                    onChange={(event) => {
                        if (props.onChange) {
                            if (props.type === "photo") props.onChange(event.target.files[0]);
                            else {
                                if (props.type === "number") {
                                    if (event.target.value !== "") {
                                        let t = 0;
                                        event.target.value = String(event.target.value)
                                            .replace(/^(0+)(\d)/g, "$2")
                                            .replace(/,/g, '.')
                                            .replace(/[^0-9.]/g, '')
                                            .replace(/\./g, match => ++t >= 2 ? '' : match);
                                    } else {
                                        event.target.value = 0;
                                    }
                                } else if (props.type === "currency"){
                                    const includesDash = event.target.value.includes('-')
                                    event.target.value = Number(`${event.target.value}`.replace(/[^\d]+/g, '')) / 100;
                                    if((event.nativeEvent.data === '-' || includesDash) && event.nativeEvent.data !== '+') {
                                        event.target.value = '-' + event.target.value;
                                    }
                                } 
                                props.onChange(event);
                            }
                        }
                    }}
                    // onChange={(event) => { props.type === 'photo' ? props.onChange(event.target.files[0]) : props.onChange(event) }}
                    ref={input}
                />
            );
        }
    }

    return (
        <div className='input-container'>
            {
                (props.hideLabel !== true & props.showFileLabel) ?
                    <label
                        onClick={() => input.current.click()}
                        className={'input-label'}
                    >
                        {(props.icon && !props.showFileLabel) ? props.icon : null}
                        <span>
                            {props.label ? props.label : 'Label'}
                        </span>
                    </label>
                    : []
            }
            {
                props.hideLabel !== true ?
                    <div className='input-labels'>
                        <label
                            onClick={() => input.current.click()}
                            className={'input-label ' + ((props.type === 'file' || props.type === 'photo') ? 'file-label ' : '') + (props.className ? props.className : "")}
                        >
                            {props.icon}
                            <span>
                                {(props.showFileLabel && props.placeholder) ? props.placeholder : (props.label ? props.label : 'Label')}
                            </span>
                        </label>

                        {
                            props.type === 'photo' ?
                                <>
                                    <button
                                        type='button'
                                        onClick={() => setPopupNewPhotoVisible(true)}
                                        className='input-new-photo'
                                    >
                                        <FaCamera />
                                    </button>
                                    <PopupNewPhoto
                                        visibility={popupNewPhotoVisible}
                                        setVisibility={setPopupNewPhotoVisible}
                                        setPhoto={props.onChange}
                                    />
                                </>
                                : []

                        }

                        {
                            props.filePreview ? (
                                props.value ?
                                    <img src={props.value} alt="foto de usuário" />
                                    :
                                    <div className={'photo-preview ' + props.className} />
                            ) : []
                        }
                    </div>
                    : []
            }
            <div className={'input-component' + ((props.type === 'file' || props.type === 'photo') ? ' file-input' : '')}>
                {
                    props.placeholderIcon ?
                        <label className="icon-label" onClick={() => input.current.click()}>
                            {props.placeholderIcon}
                        </label>
                        : []
                }

                {selectInput(props.type)}

                {
                    (props.cleanValue !== undefined || props.type === "select") && input.current ?
                        <button
                            type='button'
                            className={"input-clean"
                                + (isOnFocus &&
                                    (
                                        (props.cleanValue && input.current.value !== String(props.cleanValue))
                                        || (props.type === "select" && input.current.value !== "")
                                    ) ? "" : " hide"
                                )
                            }
                            onClick={(event) => {
                                if (props.onChange) {
                                    input.current.value = (props.cleanValue ? props.cleanValue : "");
                                    props.onChange({ ...input, target: { value: props.cleanValue ? props.cleanValue : "" } });
                                }
                            }}
                        >
                            <FaTimes />
                        </button>
                        : null
                }
            </div>
        </div>
    )
}

export default Input;